import axios, { AxiosRequestConfig } from 'axios';
import { HOST_API } from '../config';
import Cookies from 'js-cookie';

const axiosInstance = axios.create({
  baseURL: HOST_API,
  withCredentials: false, // ← schimbat din true în false
});

const onRequest = (config: AxiosRequestConfig) => {
  if (
    (config.method === 'post' ||
      config.method === 'put' ||
      config.method === 'delete') &&
    !Cookies.get('XSRF-TOKEN')
  ) {
    return setCSRFToken().then(() => config);
  }

  return config;
};

const setCSRFToken = () => {
  return axiosInstance.get('/sanctum/csrf-cookie');
};

axiosInstance.interceptors.request.use(onRequest, null);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) =>
    Promise.reject(
      (error.response && error.response.data) || 'Something went wrong',
    ),
);

export default axiosInstance;